import { useState, useEffect } from "react"
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { BASE_AUTH_URL } from '../auth';
import { http } from "../auth";


const MetadataProvider = ({ children }) => {
  const [metadata, setMetadata] = useState("");
  const [favicon,setFavicon] = useState("");

  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        const response = await http.get(`/config/intranet_config_residencial/metadatos`);;
        setMetadata(response.data);
      } catch (error) {
        console.error('Error fetching metadata:', error);
      }
    };
    fetchMetadata();
  }, []);

  useEffect(() => {
    const fetchFavicon = async () => {
      try {
        const response = await http.get(`/config/intranet_config_residencial/favicon`);
        setFavicon(response?.data);
      } catch (error) {
        console.error('Error fetching metadata:', error);
      }
    };
    fetchFavicon();
  }, []);
  
  return (
    <HelmetProvider>
      <Helmet>
        <link rel="icon" href={favicon?.favicon} />
        <title>{metadata?.title_web}</title>
        <meta name="description" content={metadata?.description} />
        <meta property="og:title" content={metadata?.title} />
        <meta property="og:description" content={metadata?.description} />
        <meta property="og:image" content={BASE_AUTH_URL + "/image/logo_app_out"} />
        <meta property="og:url" content={metadata?.url} />
      </Helmet>
      {children}
    </HelmetProvider>
  );
};
export default MetadataProvider;